import React from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LoadingOverlay = ({ message, fullscreen = false }) => {
  const { t } = useTranslation();
  const loadingMessage = message || t('loading');

  return (
    <div className={`loading-overlay d-flex justify-content-center align-items-center ${fullscreen ? 'position-fixed vh-100 vw-100 top-0 start-0' : 'p-5'}`}>
      <div className="text-center">
        <CircularProgress size={48} sx={{ color: 'var(--brand-red, #dc354d)' }} className="mb-3" />
        <p className="mb-0">{loadingMessage}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
